<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body {
  background-color: #938783 !important;
}
.invalid-error{
  width: 100%;
  margin-top: 0.25rem;
  font-size: .875em;
  color: #dc3545;
}
.title h5{
  font-size: 22px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 1.5em;
  padding-bottom: 10px;
  position: relative;
}
.title h5::before{
  position: absolute;
  left: 0;
  bottom: 0;
  width: 60px;
  height: 2px;
  content: "";
  background-color: #c50000;
}
.bg-white, .taskform {
  background-color: #FFF;
  padding: 20px;
}

.head {
  background-color: #434;
  padding: 20px;
  display: flex;
  justify-content: space-between;
}

.logo {
  height: 50px;
}</style>
